import {
	GET_ORGANIZATIONS_SUCCESS,
	ADD_ADMIN_ORGANIZATION,
	DELETE_ADMIN_ORGANIZATION,
	UPDATE_ADMIN_ORGANIZATION
} from '../../Actions/Admin/ManageOrganizationActions';

const initialState = {
	allOrganization: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ORGANIZATIONS_SUCCESS:
			return {
				...state,
				loading: true,
				allOrganization: action.payload
			};
		case ADD_ADMIN_ORGANIZATION:
		return {
			...state,
			allOrganization: action.payload
		};
		case DELETE_ADMIN_ORGANIZATION:
		return {
			...state,
			allOrganization: action.payload
		};
		case UPDATE_ADMIN_ORGANIZATION:
		return {
			...state,
			allOrganization: action.payload
		};
		default:
			return state;
	}
};
